import { useCallback } from 'react';

import { useMutation, gql } from '@apollo/client';

import {
  EditCommentToEventDocument,
  EditCommentToEventMutationVariables,
} from './Event.mutation.generated';

export const useEventEditComment = () => {
  const [runMutation, status] = useMutation(EditCommentToEventDocument);

  const execute = useCallback(
    async (variables: EditCommentToEventMutationVariables) => {
      const res = await runMutation({
        variables,
        refetchQueries: ['LiveGetLastPosts', 'LiveGetPosts'],
        update: (cache) => {
          cache.updateFragment(
            {
              id: `lives_post:${variables?.postId}`,
              fragment: gql`
                fragment EditComment on lives_post {
                  id
                  data
                }
              `,
            },
            (data) => {
              return {
                ...data,
                data: variables?.data,
              };
            }
          );
        },
      });
      return res;
    },
    [runMutation]
  );

  return { execute, status };
};
